const GET_FEATURES = 'publicadorProf/extras/GET_FEATURES';
const GET_FEATURES_COMPLETED = 'publicadorProf/extras/GET_FEATURES_COMPLETED';
const GET_FEATURES_FAILED = 'publicadorProf/extras/GET_FEATURES_FAILED';
const UPDATE_FEATURE_CHECKBOX = 'publicadorProf/extras/UPDATE_FEATURE_CHECKBOX';
const UPDATE_FEATURE_SELECT = 'publicadorProf/extras/UPDATE_FEATURE_SELECT';
const UPDATE_FEATURE_INPUT = 'publicadorProf/extras/UPDATE_FEATURE_INPUT';
const RESET_STATE = 'publicadorProf/extras/RESET_STATE';

export {
  GET_FEATURES,
  GET_FEATURES_COMPLETED,
  GET_FEATURES_FAILED,
  UPDATE_FEATURE_CHECKBOX,
  UPDATE_FEATURE_SELECT,
  UPDATE_FEATURE_INPUT,
  RESET_STATE
};
